"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemFactoryFromJS = exports.ItemFactory = void 0;
const core_1 = require("@bimser/core");
const immutable_1 = require("immutable");
exports.ItemFactory = (0, immutable_1.Record)({
    key: null,
    text: null,
    icon: null,
    selected: null,
    passive: null,
    disabled: null,
    type: null,
    additionalLabel: null,
    groupKey: null,
    isGroup: null,
    items: null,
    draggable: false,
    contextMenuItems: (0, immutable_1.List)()
});
const ItemFactoryFromJS = function (data) {
    const items = data && data.items ? data.items.map(i => (0, exports.ItemFactoryFromJS)(i)) : [];
    const contextMenuItems = data && data.contextMenuItems
        ? data.contextMenuItems.map(i => (0, core_1.ItemFactoryFromJS)(i))
        : [];
    return (0, exports.ItemFactory)(Object.assign(Object.assign({}, data), { items: (0, immutable_1.List)(items), contextMenuItems: (0, immutable_1.List)(contextMenuItems) }));
};
exports.ItemFactoryFromJS = ItemFactoryFromJS;
//# sourceMappingURL=IItem.js.map